// https://vuex.vuejs.org/en/getters.html

const getters = {
  getToken: state => state.api.token == null ? null : state.api.token,
  getProfile: state => (state.profile.username == null || state.profile.username == undefined) ? null : state.profile,
  getLanguage: state => (state.profile.language == null || state.profile.language == undefined) ? null : state.profile.language
};

export default getters;
